export const RESET_PARTICIPANT_DATA = "reset_participant_data"


export const setParticipantData = (data) => {
  return { type: RESET_PARTICIPANT_DATA, payload: data }
}
